jQuery(function ($) {
	const $body = $('body');
	const $single = $('.single-works');
	const $loader = $('.single-works__loader');
	if (!$single.length) return;

	const ARCHIVE_KEY = 'worksArchiveState';
	const pathParts = window.location.pathname.split('/').filter(Boolean);
	pathParts.pop();
	const ARCHIVE_BASE = window.location.origin + '/' + pathParts.join('/') + '/';

	let scrollThrottle = false;
	let touchStartX = 0;
	let touchStartY = 0;
	let isSwiping = false;

	const cleanUrl = url => url.split('#')[0];

	const openOverlay = () => {
		$single.addClass('is-visible');
		$body.addClass('is-single-open');
	};

	const closeOverlay = function (e) {
		e.preventDefault();
		const archiveState = sessionStorage.getItem(ARCHIVE_KEY);

		if (archiveState) {
			const state = JSON.parse(archiveState);
			const baseUrl = cleanUrl(state.url);

			if (baseUrl === ARCHIVE_BASE && state.scroll > 0) {
				window.location.href = ARCHIVE_BASE + '#scroll=' + state.scroll;
				return;
			}
		}

		window.location.href = ARCHIVE_BASE;
	};

	const fetchSingle = function (url, push = true) {
		if (!url) return;

		$single.addClass('is-loading');
		$loader.addClass('is-active');

		$.get(url, function (response) {
			const $newContainer = $(response).find('.single-works__container').html();
			const $newNavigation = $(response).find('.single-works__navigation').html();

			if ($newContainer) {
				$single.find('.single-works__container').html($newContainer);
			}

			if ($newNavigation) {
				$single.find('.single-works__navigation').html($newNavigation);
			}

			if (push) {
				window.history.pushState({ url: url }, '', url);
			}

			$single.removeClass('is-loading');
			$loader.removeClass('is-active');

			prefetchNav();

			window.scrollTo({ top: 0 });
		});
	};

	const handleKeyboard = function (e) {
		if (e.key === 'Escape') $('.single-works__close').trigger('click');
		if (e.key === 'ArrowRight') $('.single-works__side-nav--next a').trigger('click');
		if (e.key === 'ArrowLeft') $('.single-works__side-nav--prev a').trigger('click');
	};

	const prefetchNav = () => {
		const next = $('.single-works__side-nav--next a').attr('href');
		const prev = $('.single-works__side-nav--prev a').attr('href');

		[next, prev].forEach(url => {
			if (!url) return;
			const link = document.createElement('link');
			link.rel = 'prefetch';
			link.href = url;
			document.head.appendChild(link);
		});
	};

	const handleScrollNav = e => {
		if (scrollThrottle) return;
		scrollThrottle = true;

		const delta = e.originalEvent.deltaX || e.originalEvent.wheelDeltaX || 0;

		if (delta > 0) $('.single-works__side-nav--next a').trigger('click');
		else if (delta < 0) $('.single-works__side-nav--prev a').trigger('click');

		setTimeout(() => {
			scrollThrottle = false;
		}, 600);
	};

	$single.on('wheel', handleScrollNav);

	$single.on('touchstart', function (e) {
		touchStartX = e.originalEvent.touches[0].clientX;
		touchStartY = e.originalEvent.touches[0].clientY;
		isSwiping = true;
	});

	$single.on('touchend', function (e) {
		if (!isSwiping) return;

		const touchEndX = e.originalEvent.changedTouches[0].clientX;
		const touchEndY = e.originalEvent.changedTouches[0].clientY;

		const deltaX = touchEndX - touchStartX;
		const deltaY = touchEndY - touchStartY;

		const threshold = 60;

		if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
			if (deltaX < 0) {
				$('.single-works__side-nav--next a').trigger('click');
			} else {
				$('.single-works__side-nav--prev a').trigger('click');
			}
		}

		isSwiping = false;
	});

	$(document).on('click', '.single-works__image', function () {
		const $img = $(this);
		if ($img.hasClass('is-fullscreen')) {
			$img.removeClass('is-fullscreen');
			$body.removeClass('is-image-fullscreen');
		} else {
			$img.addClass('is-fullscreen');
			$body.addClass('is-image-fullscreen');
		}
	});

	openOverlay();

	$(document).on('click', '.single-works__close', closeOverlay);

	$(document).on('click', '.single-works__side-nav a', function (e) {
		e.preventDefault();

		const url = $(this).attr('href');

		sessionStorage.setItem(ARCHIVE_KEY, JSON.stringify({
			url: ARCHIVE_BASE,
			scroll: window.scrollY
		}));

		fetchSingle(url, true);
	});

	$(document).on('keydown', handleKeyboard);

	window.addEventListener('popstate', function (event) {
		if (event.state && event.state.url) {
			fetchSingle(event.state.url, false);
		}
	});

	prefetchNav();
});